var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-percent-pond',{key:_vm.refreshFlagKey,staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.pondConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }